module.exports = __webpack_public_path__ + "img/icon-add.85977819.svg";